import React from "react";
import { Link } from "react-router-dom";
import "./pagenotfound.css";

export default function PageNotFound() {
  return (
    <>
      <body className="g-sidenav-show  bg-gray-200 err_bg">
        <div class="mainbox">
          <div class="msg_1">OOPS! we have a</div>
          <div class="err">4</div>
          <div class="err0">0</div>
          <div class="err2">4</div>
          <div class="msg">error</div>
          <div class="error">
            {/* <Link to="/" class="btn-primary blue_btn">
                home
              </Link>{" "} */}
            <Link to="/">
              <button class="btn-primary blue_btn w-100" type="button">
                Error...TAKE ME HOME
              </button>
            </Link>
          </div>
        </div>
      </body>
    </>
  );
}
